import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { Maybe, AnalyticsContext } from '@/types/generated';
import { errorPageView } from '@shared-components/constants';
import { useAppContext, useFacilityContext } from '@shared-components/context';
import { useInitialReferrer } from '@shared-components/index';
import { dataLayerConfig, sendFacebookEvent } from '@utils';
export interface IPageView {
  error?: string;
  analyticsContext?: Maybe<AnalyticsContext>;
  /**
   * Specifies which app this gets called from.
   * Eg: Marketing, Office Details etc
   *
   * @type {string}
   * @memberof IPageView
   */
  siteSection?: string;
  pageReferrer?: string;
}
const PageView = ({
  error = '',
  analyticsContext,
  siteSection = '',
  pageReferrer
}: IPageView) => {
  const {
    config,
    stateCodeFromHeaders
  } = useAppContext();
  const {
    facilityCode,
    officeInfo
  } = useFacilityContext();
  const pathname = usePathname();
  useInitialReferrer();
  useEffect(() => {
    dataLayerConfig({
      event: analyticsContext?.event || 'page_view',
      brand: config.name || analyticsContext?.brand || '',
      location: '',
      location_status: '',
      page_referrer: globalThis?.document?.referrer || '',
      ...(analyticsContext ?? undefined),
      ...(error && errorPageView[error]),
      is_404: String(error) === '404',
      ...(stateCodeFromHeaders && {
        state: stateCodeFromHeaders
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  const facilityName = officeInfo?.name;
  useEffect(() => {
    if (!analyticsContext && facilityCode && facilityName) {
      const isMobile = /mobile/i.test(navigator?.userAgent);
      const deviceType = isMobile ? 'mobile' : 'desktop';
      dataLayerConfig({
        event: 'virtual_page_view',
        brand: config.name,
        ...(siteSection && {
          site_section: siteSection
        }),
        virtual_page_url: globalThis?.location?.href,
        virtual_page_title: globalThis?.document?.title,
        device_type: deviceType,
        website_selected_facility_id: facilityCode,
        website_selected_facility_name: facilityName,
        is_404: String(error) === '404',
        ...(pageReferrer && {
          page_origin_url: pageReferrer
        }),
        ...(stateCodeFromHeaders && {
          state: stateCodeFromHeaders
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analyticsContext, facilityCode, pathname, facilityName]);
  useEffect(() => {
    if (config.features.analytics.facebookPixel) {
      sendFacebookEvent('PageView');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
export default PageView;